exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".about-you-container{padding:20px 0 15px;border-bottom:1.5px solid #f39594;color:#f39594;font-size:18px;font-weight:500;width:130px;margin:35px 0}.question{font-weight:600;font-size:16px;line-height:22px;color:#4b7589}.options-container{display:flex;align-items:center;padding:50px 0;justify-content:center}@media(max-width:768px){.options-container{flex-direction:column}}.options-container span{text-decoration:underline;color:#b5dae3;font-weight:400;font-size:16px;cursor:pointer}.options-container .input-options{display:flex}@media(max-width:768px){.options-container .input-options{flex-direction:column}}", ""]);

// exports
